import { Markdown } from 'Common';
import markdownContent from '!!raw-loader!static/imprint.md';
import TermsModal from './TermsModal';

export default function ImprintLink({ className, color }) {
  return (
    <TermsModal
      buttonColor="link"
      buttonClasses={className}
      modalHeaderText="Impressum"
      buttonText="Impressum"
      color={color}
      renderTypeProps={{ ['aria-label']: 'Öffnet das Impressum im Popup' }}
      renderAs="link"
    >
      <Markdown className="popup" containerId="modal-body" scrollOffset={0}>
        {markdownContent}
      </Markdown>
    </TermsModal>
  );
}
